import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconChevronLeftSmall = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M13.477 9.54A.741.741 0 0 0 13.71 9a.741.741 0 0 0-.234-.54.73.73 0 0 0-.54-.21.701.701 0 0 0-.515.21l-3 3a.782.782 0 0 0-.211.54c0 .203.07.383.21.54l3 3c.142.14.313.21.517.21a.73.73 0 0 0 .539-.21.741.741 0 0 0 .234-.54.741.741 0 0 0-.234-.54L11.016 12l2.46-2.46z" }),
});

export { IconChevronLeftSmall };
